import { Directive, HostListener, ElementRef, OnInit, AfterViewInit, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumberFormat]',
  standalone: true
})
export class NumberFormatDirective implements OnInit, AfterViewInit {
  private el = inject(ElementRef);
  private ngControl = inject(NgControl, { optional: true });
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.listenToControlChanges();
  }

  ngAfterViewInit() {
    this.formatCurrentValue();
  }

  // Escucha cambios del control para formatear valores cargados
  private listenToControlChanges() {
    this.ngControl?.valueChanges?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.formatCurrentValue();
    });
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    this.applyFormattedValue(this.el.nativeElement.value ?? '');
    event.target.value = this.el.nativeElement.value;
  }

  // Formatea el valor actual si existe en el control o elemento nativo
  private formatCurrentValue() {
    const current = String(this.ngControl?.value ?? this.el.nativeElement.value ?? '');
    if (current) this.applyFormattedValue(current);
  }

  // Asigna el valor formateado al elemento nativo y al control reactivo
  private applyFormattedValue(value: string) {
    const raw = value.endsWith('.') ? `${value.slice(0, -1)},` : value.replace(/\./g, '');
    const formatted = this.formatNumber(raw);
    if (this.el.nativeElement.value !== formatted) this.el.nativeElement.value = formatted;
    if (this.ngControl?.control && this.ngControl.value !== formatted) {
      this.ngControl.control.setValue(formatted, { emitEvent: false });
    }
  }

  // Formatea una cadena numérica insertando puntos de miles
  formatNumber(value: string): string {
    const [integerPart, decimalPart = ''] = value.split(',');
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return value.includes(',') ? `${formattedInteger},${decimalPart}` : formattedInteger;
  }
}

